import * as React from 'react';

const ChevronLeftChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8 7l-5 5 5 5 1.4-1.4-3.6-3.6 3.6-3.6z"
        />
    </svg>
);

ChevronLeftChunkySvg.displayName = 'ChevronLeftChunkySvg';
export default ChevronLeftChunkySvg;
